import { useBranding } from "../context/BrandingContext";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const useLogoUrl = (light) => {
  const { branding } = useBranding();
  const isDark = document.documentElement.classList.contains("dark");
  const themed = (isDark || light) ? branding.assets.logo_dark : branding.assets.logo_light;
  return themed || branding.assets.logo_main;
};

export const BrandIcon = ({ size = "md" }) => {
  const { branding } = useBranding();
  const logo = useLogoUrl(false);
  const boxCls = { sm: "h-9 w-9", md: "h-12 w-12", lg: "h-16 w-16" }[size] || "h-12 w-12";

  return (
    <img
      data-testid={logo ? "brand-logo-icon" : "brand-logo-icon-default"}
      src={logo ? `${BACKEND}${logo}` : "/logo.png"}
      alt={branding.app_name}
      className={`${boxCls} object-contain rounded-xl drop-shadow-[0_0_10px_rgba(224,0,0,0.45)]`}
    />
  );
};

export const BrandLogo = ({ size = "md", light = false, textOnly = false }) => {
  const { branding } = useBranding();
  const logo = useLogoUrl(light);
  const sizeCls = { sm: "h-7", md: "h-9", lg: "h-12" }[size] || "h-9";
  const textCls = { sm: "text-lg sm:text-xl", md: "text-base sm:text-2xl", lg: "text-2xl sm:text-3xl" }[size] || "text-2xl";

  if (logo && !textOnly) {
    return (
      <img
        data-testid="brand-logo-img"
        src={`${BACKEND}${logo}`}
        alt={branding.app_name}
        className={`${sizeCls} w-auto object-contain`}
      />
    );
  }
  return (
    <span
      data-testid="brand-logo-text"
      className={`${textCls} font-bold ${light ? "text-white" : "bg-gradient-to-r from-purple-600 via-brand-red to-pink-600 bg-clip-text text-transparent"}`}
    >
      {branding.app_name}
    </span>
  );
};

export default BrandLogo;
